import _ from 'lodash';
import queryString from 'query-string';

import { PageQueryOptions, SortParams } from '@breathelife/types';

export function buildPageQueryOptions<T, U>({
  $limit,
  $page,
  $sort,
  $search,
  $searchMode,
  $filter,
}: PageQueryOptions<T, U>): PageQueryOptions<T, string> {
  return {
    ...(typeof $limit !== 'undefined' ? { $limit } : {}),
    ...(typeof $page !== 'undefined' ? { $page } : {}),
    ...(typeof $sort !== 'undefined' ? { $sort } : {}),
    ...(typeof $search !== 'undefined' ? { $search } : {}),
    ...(typeof $searchMode !== 'undefined' ? { $searchMode } : {}),
    ...(typeof $filter !== 'undefined' ? { $filter: JSON.stringify($filter) } : {}),
  };
}

export function convertObjectToQueryString<T>(options: { [key: string]: any } & { $sort?: SortParams<T> }): string {
  const { $sort, ...rest } = options;
  let sortQuery = undefined;
  const query = queryString.stringify(rest, { arrayFormat: 'comma' });
  if ($sort) {
    sortQuery = buildSortQuery($sort);
  }
  const queries = _.compact([query, sortQuery]);
  return `?${queries.join('&')}`;
}

export function buildSortQuery<T>(sortOptions: SortParams<T>): string {
  const { field, direction } = sortOptions;

  return `$sort[${typeof field === 'string' ? field : String(field)}]=${direction}`;
}
